import { Theme } from "../themeInterfaces";
import { sharedValues } from "../themesSharedValues";
import { stbColors } from "./storebrandColors";

export const stbTheme: Theme = {
  ...sharedValues,

  brandColors: stbColors,
  buttons: {
    color: stbColors.primary,
    hover: stbColors.primaryVariant,
    pressed: stbColors.primaryPressed,
    text: stbColors.white,
    textHover: stbColors.primary,
    border: `1px solid ${stbColors.primary}`,
    sendEmailButtonColor: stbColors.primary,
  },
  brandedParagraph: {
    backgroundColor: stbColors.white,
    textColor: stbColors.black,
  },
  discountMessage: {
    backgroundColor: stbColors.alert.success.background,
    textColor: stbColors.black,
  },
  headingColor: stbColors.black,
  table: {
    backgroundColor: stbColors.surface.main,
    column: stbColors.alert.success.background,
    hover: stbColors.surface.hover,
  },
  insuranceDetailsCard: {
    backgroundColor: stbColors.surface.variant,
    notSelectedBackgroundColor: stbColors.greenBackground,
    textColor: stbColors.black,
    buttonColor: stbColors.primary,
    border: `4px solid ${stbColors.surface.variant}`,
  },
  link: stbColors.primary,
  productsLink: {
    wrapperColor: stbColors.alert.info.background,
  },
  surface: {
    color: stbColors.surface.main,
    border: stbColors.surface.border,
  },
  showIllustration: true,
};
